import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Swal from 'sweetalert2';
import {parse as parseMoney} from 'vue-currency-input';
import {getField, updateField} from 'vuex-map-fields';

import {localize as veeLocalize} from 'vee-validate/dist/vee-validate.full';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    page: 1,
    formSubmitLoading: false,
    generalErrors: [],
    storage_uid: localStorage.getItem('storage_uid') || null,
    last_interaction: localStorage.getItem('last_interaction') || new Date(),
    canProceedToNextPage: false,
    connection: '',
    product_code: '',
    code: false,
    insuranceYearlyPrice: null,

    last_email: null,
    merchant_id: 'colo213',
    igeny_azon_href: null,
    cities: [],
    countries: [],
    itemList: [],
    marks: {},

    // General page fields
    insuranceType: 1,
    fromCountry: 'HU',
    toCountry: 'HU',
    condition: 'alt',
    clause: 'alt_a',

    shipmentType: 'uj',
    currency: 'huf',
    insuranceAmount: null,
    shipmentValue: null,
    shipmentCategory: 1,
    shipmentName: '',
    compensationFund: 'uj_1',
    hasVehicleTransport: true,
    hasTrainTransport: false,
    hasShipTransport: false,
    hasAirTransport: false,

    deductibleAmount: 'szazalek',
    parity: '',

    insuranceStart: new Date().setDate(new Date().getDate() + 1),
    insuranceEnd: new Date().setDate(new Date().getDate() + 1),

    paymentType: 'atutalas',

    // Contract page fields
    companyName: '',
    companyVat: '',
    companyPostalCode: '',
    companyCity: '',
    companyAddress: '',
    companyEmail: '',
    companyPhoneArea: 20,
    companyPhone: '',

    companyIsTheInsured: 1,

    insuredName: '',
    insuredPostalCode: '',
    insuredCity: '',
    insuredAddress: '',

    statementSettings: {
      privacyStatement: false,
      insuranceTerms: false,
      electronicCommunation: false,
      marketingMails: false,
      acceptTerms: false,
      validMerchant: false,
      validDatas: false,
      merchantInformedCustomer: false,
      sanctionsStatement: false,
      ekapcsolatStatement: false,
      orosz_nyilatkozat: false,
    },
  };
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: getDefaultState(),
  //   state: {
  //     page: 1,
  //     formSubmitLoading: false,
  //     generalErrors: [],
  //     storage_uid: localStorage.getItem('storage_uid') || null,
  //     last_interaction: localStorage.getItem('last_interaction') || new Date(),
  //     canProceedToNextPage: false,
  //     connection: '',

  //     insuranceYearlyPrice: null,

  //     last_email: null,
  //     merchant_id: 'colo213',

  //     cities: [],
  //     countries: [],
  //     itemList: [],
  //     marks: {},

  //     // General page fields
  //     insuranceType: 1,
  //     fromCountry: 'HU',
  //     toCountry: 'HU',
  //     condition: 'alt',
  //     clause: 'alt_a',

  //     shipmentType: 'uj',
  //     currency: 'huf',
  //     insuranceAmount: null,
  //     shipmentValue: null,
  //     shipmentCategory: 1,
  //     shipmentName: '',
  //     compensationFund: 'uj_1',
  //     hasVehicleTransport: true,
  //     hasTrainTransport: false,
  //     hasShipTransport: false,
  //     hasAirTransport: false,

  //     deductibleAmount: 'nincs',
  //     parity: '',

  //     insuranceStart: new Date().setDate(new Date().getDate() + 1),
  //     insuranceEnd: new Date().setDate(new Date().getDate() + 1),

  //     paymentType: 'online',

  //     // Contract page fields
  //     companyName: '',
  //     companyVat: '',
  //     companyPostalCode: '',
  //     companyCity: '',
  //     companyAddress: '',
  //     companyEmail: '',
  //     companyPhoneArea: 20,
  //     companyPhone: '',

  //     companyIsTheInsured: 1,

  //     insuredName: '',
  //     insuredPostalCode: '',
  //     insuredCity: '',
  //     insuredAddress: '',

  //     statementSettings: {
  //       privacyStatement: false,
  //       insuranceTerms: false,
  //       electronicCommunation: false,
  //       marketingMails: false,
  //       acceptTerms: false,
  //       validMerchant: false,
  //       validDatas: false,
  //     },
  //   },
  getters: {
    getField,
    getAllState: (state) => {
      const doNotIncludeArray = [
        'canProceedToNextPage',
        'storage_uid',
        'last_interaction',
        'generalErrors',
        'marks',
        'email_valid_code',
        'last_email',
        'formSubmitLoading',
        'merchant_id',
        'insuranceYearlyPrice',
        'igeny_azon_href',
        'cities',
        'countries',
        'itemList',
      ];
      const filtered = Object.keys(state)
        .filter((key) => !doNotIncludeArray.includes(key))
        .reduce((obj, key) => {
          obj[key] = state[key];
          return obj;
        }, {});

      return filtered;
    },
  },
  mutations: {
    updateField,
    incrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page < 5) {
        state.page++;
      }
      window.scrollTo(0, 0);
    },
    decrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page > 1) {
        state.page--;
      }

      window.scrollTo(0, 0);
    },
    setFormSubmitLoading(state, status) {
      state.formSubmitLoading = status;
    },

    setConnection(state, value) {
      state.connection = value;
    },
    setNavigationBackButton(state, value) {
      state.isBackButtonDisabled = value;
    },
    setProductCode(state, code) {
      state.product_code = code;
    },
    // page allowing
    setNextPageStatus(state, status) {
      const now = new Date();
      const ONE_HOUR = 60 * 60 * 1000;
      const date = new Date(state.last_interaction);
      if (now - date > ONE_HOUR * 2) {
        this.commit('setStorageUid', null);
      }
      state.last_interaction = now;
      localStorage.setItem('last_interaction', now);
      state.canProceedToNextPage = status;
    },

    // storage uid
    setStorageUid(state, uid) {
      if (!uid) {
        state.storage_uid = null;
        localStorage.removeItem('storage_uid');
      } else {
        state.storage_uid = uid;
        localStorage.setItem('storage_uid', uid);
      }
    },
    setClaimIdentifierUrl(state, url) {
      state.igeny_azon_href = url;
    },
    //igenyazonosito
    setClaimIdentifier(state, code) {
      state.code = code;
    },
    updateStatements(state, {name, value}) {
      if (state.statementSettings[name] != undefined) state.statementSettings[name] = value;
    },

    // general errors
    setGeneralErrors(state, errors) {
      errors.forEach((error) => {
        if (!state.generalErrors.includes(error)) Vue.$toast.error(error);
      });
      state.generalErrors = errors;
    },

    setInsuranceYearlyPrice(state, price) {
      state.insuranceYearlyPrice = price;
    },

    setMarks(state, marks) {
      state.marks = marks;
    },

    setCities(state, cities) {
      state.cities = cities;
    },

    setCountries(state, countries) {
      state.countries = countries;
    },

    setItemList(state, itemList) {
      state.itemList = itemList;
    },
  },
  actions: {
    getMarks(context) {
      const params = new URLSearchParams();

      params.append('marks', 1);

      axios
        .post(`${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`, params)
        .then((res) => {
          const data = res.data.data;
          if (data?.marks) {
            context.commit('setMarks', data.marks);
            context.commit('setConnection', data.connection);

            context.dispatch('updateMarks', data.marks);

            if (data.marks.colonnade_version && context.state.page === 1) {
              Swal.fire({
                icon: 'info',
                html: `Verzió: ${data.marks.colonnade_version}`,
                showCloseButton: true,
                showConfirmButton: false,
              });
            }
          }

          if (data?.error_messages?.code) {
            veeLocalize('hu', data.error_messages);
          }
        })
        .catch((err) => {
          console.error('Nem sikerült betölteni a marks-okat.');
          console.error(err);
        });
    },
    async verifyPage(context, process_id) {
      if (process_id === 4 && context.state.formSubmitLoading) return;
      context.commit('setNextPageStatus', false);
      const state = context.state;

      context.dispatch('updateMarks', state.marks);

      if (!document.getElementById('form')) return;

      const formData = new FormData(document.getElementById('form'));
      const params = new URLSearchParams();

      for (let [key, val] of formData.entries()) params.append(key, val);

      if (process_id) params.append('process_id', process_id);
      else params.append('process_id', state.page);

      if (params.has('biztosszeg'))
        params.set(
          'biztosszeg',
          parseMoney(state.insuranceAmount, window.currencyInputOptions) || 0
        );
      if (params.has('aruertek'))
        params.set('aruertek', parseMoney(state.shipmentValue, window.currencyInputOptions) || 0);

      if (
        params.has('szerzodo_email') &&
        params.has('szerzodo_email_2') &&
        (!state.email_valid_code || state.last_email != state.contractSettings.email) &&
        state.contractSettings.lastName &&
        state.contractSettings.firstName
      ) {
        const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (
          !emailRegex.test(params.get('szerzodo_email')) &&
          !emailRegex.test(params.get('szerzodo_email_2'))
        )
          return;
        if (state.contractSettings.email === state.contractSettings.emailVerification)
          params.set('sendvalidemail', 1);
      }

      // setting uid param if stored
      if (state.storage_uid) params.set('storage_uid', state.storage_uid);
      if (state.merchant_id) params.set('merchant_id', state.merchant_id);

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params
        );

        if (process_id === 4) {
          context.commit('setFormSubmitLoading', false);

          // const paymentLink = result?.data?.labels?.result?.dump?.payment_href;
          // console.log(paymentLink);
          // window.location = paymentLink;

          //const paymentLink = result.data?.labels?.result?.dump?.payment_href;

          //if (paymentLink && state.merchant_id !== 'colo213') window.location = paymentLink;
        }

        //console.log(result.data);

        let data = result.data;

        if (data.fieldErrors?.length <= 0 && data.generalErrors?.length <= 0) {
          context.commit('setNextPageStatus', true);
        }

        if (data.data.connection !== state.connection) {
          context.commit('setConnection', data.data.connection);
        }
        const dbDump = data?.labels?.result?.dump;

        if (dbDump?.igeny_azon_href) {
          if (dbDump.igeny_azon_href !== context.igeny_azon_href) {
            context.commit('setClaimIdentifierUrl', null);
          }
          context.commit('setClaimIdentifierUrl', dbDump.igeny_azon_href);
        } else {
          context.commit('setClaimIdentifierUrl', null);
        }

        context.commit('setGeneralErrors', data.generalErrors);

        if (data.labels) {
          const labels = data.labels;

          if (labels.result) {
            const save = labels.result;
            const dbDump = labels.result.dump;

            if (save.id) context.commit('setStorageUid', labels.result.id);
            context.commit('setInsuranceYearlyPrice', dbDump.eves_dij || 0);

            if (dbDump?.PRODUCT_CODE) {
              context.commit('setProductCode', dbDump.PRODUCT_CODE);
            }
          }
        }

        if (process_id === 3) {
          const paymentLink = result?.data?.labels?.result?.dump?.payment_href;

          // console.log(state.paymentType);
          // console.log(state.merchant_id);
          state.merchant_id;
          if (state.paymentType === 'online' && state.merchant_id === 'colo213') {
            window.location = paymentLink;
          } else {
            if (data.data) {
              data = result.data.data;

              if (data.veglegesites_uzenet) {
                context.commit('setStorageUid', null);
                const message = data.veglegesites_uzenet;
                if (message.endsWith('.html')) {
                  axios
                    .get(message)
                    .then((res) => {
                      if (res.data) {
                        Swal.fire({
                          icon: 'info',
                          html: res.data,
                          showCloseButton: true,
                          showConfirmButton: false,
                          customClass: {
                            content: 'text-align-left',
                          },
                        });
                      }
                    })
                    .catch(() => {
                      Vue.$toast.error(
                        'Hiba történt a tartalom betöltése közben. Keressen fel minket valamelyik elérhetőségünkön.'
                      );
                    });
                } else if (message.startsWith('http://') || message.startsWith('https://')) {
                  window.location = message;
                } else {
                  Vue.$toast.info(message);
                }
              }
            }
          }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (process_id === 4) context.commit('setFormSubmitLoading', false);
        Vue.$toast.error(
          'Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.'
        );

        return Promise.reject(err);
      }
    },
    updateMarks(context, marks) {
      const validUrl = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      );

      for (let [key, value] of Object.entries(marks)) {
        if (validUrl.test(value)) {
          axios.get(value).then((res) => {
            if (res.data) value = res.data;
          });
        }

        if (key == 'csillag') {
          document.getElementById('invalid_inputs').innerHTML = value;
        } else {
          const element = document.getElementById(`${key}-tooltip`);
          if (element) {
            element.addEventListener('click', () => {
              Swal.fire({
                icon: 'question',
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                customClass: {
                  content: 'text-align-left',
                },
              });
            });
          }
        }
      }
    },
    async getSelectLists(context) {
      const apiUrl = `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`;
      const params = new URLSearchParams();

      params.append('process_id', 'listofcities');

      const cityData = await axios.post(apiUrl, params);
      const cities = cityData?.data?.data?.listofcities ?? [];

      await context.commit('setCities', cities);

      params.set('process_id', 'listofcountries');

      const countriesData = await axios.post(apiUrl, params);
      const countryList = countriesData?.data?.data?.listofcountries ?? [];

      const countries = Array.isArray(countryList) ? countryList : Object.values(countryList);

      await context.commit(
        'setCountries',
        countries.map((country) => ({
          id: country.kod,
          text: country.nev,
        }))
      );

      params.set('process_id', 'listofproducts');

      const productsData = await axios.post(apiUrl, params);
      const products = productsData?.data?.data?.listofproducts ?? [];

      await context.commit('setItemList', products);
    },
  },
});
